// extracted by mini-css-extract-plugin
module.exports = {"agreeToTerms":"AgreeToTermsModal_agreeToTerms__vCUQa"};